import _get from "lodash/get"
import _map from "lodash/map"

import { ensureArray } from "services/utils/validation"

export const formatOccurrences = (data) => {
  return _map(data, (item) => {
    const notesList = _get(item, "partnerNoteList", [])
    const occurrenceResponse = ensureArray(notesList)

    return {
      ...item,
      partnerNoteList: occurrenceResponse
    }
  })
}



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/MySpecialistRequests/utils.js